export default __webpack_public_path__ + "static/media/Banner1_revamp_En.8aa3bcc9.webp";